import i18n from '@/i18n'

export function useConfirmDialog () {
  function confirm (options) {
    return new Promise((resolve) => {
      const dialog = document.createElement('dialog')
      document.body.append(dialog)
      dialog.classList.add('confirm-dialog')
      dialog.innerHTML = `
        <h2 class="confirm-dialog__title">${options.title || i18n.t('ConfirmDialog.Title')}</h2>
        <div class="confirm-dialog__text">${options.text || i18n.t('ConfirmDialog.Text')}</div>
        <div class="confirm-dialog__button-container">
          <button class="confirm-dialog__cancel-button">${options.cancelText || i18n.t('ConfirmDialog.Cancel')}</button>
          <button class="confirm-dialog__confirm-button ${options.danger ? 'danger' : ''}" autofocus>${options.confirmText || i18n.t('ConfirmDialog.Confirm')}</button>
        </div>
      `

      dialog.querySelector('.confirm-dialog__cancel-button').onclick = () => {
        dialog.close()
        dialog.remove()
        resolve(false)
      }

      dialog.querySelector('.confirm-dialog__confirm-button').onclick = () => {
        dialog.close()
        dialog.remove()
        resolve(true)
      }

      dialog.showModal()
    })
  }

  return {
    confirm,
  }
}
